interface NumericKeyEvent {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  altKey: boolean;
}

/** Цифры плюс разделители, которые числовое поле принимает осмысленно. */
const ALLOWED_CHAR = /^[0-9.,-]$/;
const ALLOWED_TEXT = /^[0-9.,-]*$/;

/**
 * Печатаемый символ, которому нечего делать в числовом поле. Служебные клавиши
 * (Enter, Backspace, стрелки) и сочетания с Ctrl/Cmd/Alt пропускаем — иначе
 * сломается копирование и навигация по полю.
 */
export const isRejectedNumericKey = (e: NumericKeyEvent): boolean =>
  e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey && !ALLOWED_CHAR.test(e.key);

/** Годится ли вставляемый текст для числового поля целиком. */
export const isNumericText = (text: string): boolean => ALLOWED_TEXT.test(text);

/**
 * Числовые поля редакторов — обычные текстовые input'ы, поэтому в них всегда
 * может оказаться незавершённый ввод: пустая строка, «-», «12.». Унарный `+`
 * превращал такой ввод в NaN и клал его прямо в объект холста — элемент
 * ломался, а поле показывало «NaN». Здесь вместо этого остаётся прежнее
 * значение, пока пользователь не введёт настоящее число.
 */
export const toFiniteNumber = (value: string, fallback: number): number => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};
